import { environment } from './env';

export const isE2e = () => {
	return environment.ENV === 'e2e';
};

export const isA11y = () => {
	return environment.ENV === 'a11y';
};

export const isE2eOrA11y = () => {
	return isE2e() || isA11y();
};

export const isLocalhost = () => {
	return environment.ENV === 'local';
};

export const isProduction = () => {
	return environment.ENV === 'live' || environment.ENV === 'develop';
};

export const isDevelop = () => {
	return environment.ENV === 'develop';
}
export const isLocalhostOrE2e = (): boolean => {
	return isLocalhost() || isE2e() || isA11y();
};
